var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonLink } from '@marketing/components/global/CTA/Button';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { foregroundToBackgroundColorMap } from '@marketing/variables';
function ContactSection(_a) {
    var content = _a.content, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'beige' : _b;
    var title = content.title, subheading = content.subheading, buttonLabel = content.buttonLabel, hasExternalLink = content.hasExternalLink;
    var backgroundColorStyle = foregroundToBackgroundColorMap[backgroundColor];
    return (_jsxs(FlexSection, __assign({ paddingStyle: "px-2xs-gutter py-lg-gutter md:px-4xl-gutter md:py-lg-gutter", gapStyle: "gap-xl-m md:gap-[30px]", backgroundColorStyle: backgroundColorStyle, className: "!flex-col items-center text-center" }, { children: [_jsxs("div", { children: [_jsx(Heading, __assign({ size: "md" }, { children: title })), _jsx("p", __assign({ className: "mt-xs-m" }, { children: subheading }))] }), _jsx(ButtonLink, __assign({ href: content.ctaUrl, target: hasExternalLink ? '_blank' : undefined, rel: hasExternalLink ? 'noopener noreferrer' : undefined, use: "secondary", size: "small", className: "w-[180px] md:w-[192px]" }, { children: buttonLabel }))] })));
}
export default ContactSection;
